import {
	API_URL,
} from "./const";

export declare type GetLocationDataOptions = {
	attempt: number;
}

export declare type GetLocationDataResult = {
	"CloudFront-Viewer-Country": string;
	"CloudFront-Viewer-Country-Name": string;
	"CloudFront-Viewer-Postal-Code": string;
}

export const getLocationData = async( address:string, options: GetLocationDataOptions = { attempt:0, }): Promise<GetLocationDataResult> => {

	try {

		const response = await fetch(`${API_URL}/echo?account=${address}`, {
			method: "GET",
			headers: {
				"Accept": "application/json",
				"x-api-key": import.meta.env.VITE_APP_X_API_KEY,
			}
		});

		if(response.ok) {
			const result = await response.json();
			if(typeof result === "object" && !Array.isArray(result) && result !== null) {
				return result;
			}
		}
		throw new Error(`failed gaining location metrics on attempt ${options.attempt}`)
	}
	catch( err ) {
		if(options.attempt < 3) {
			return await getLocationData(address, { attempt: options.attempt + 1, });
		}
		throw new Error("failed gaining locatin metrics");
	}

}
